import { Component } from '@angular/core';
import { ApplicationContextService, RolePermissionService } from 'lib-core-shared';
import { ControlBaseDirective } from '../../directives/control-base.directive';

@Component({
  selector: 'lib-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css']
})

export class DatePickerComponent extends ControlBaseDirective {

  constructor(public roleService: RolePermissionService, public applicationContext: ApplicationContextService) { 
    super(roleService, applicationContext);
  }

}

